<div class="module-inactive bg-light-shadow"
     *ngIf="(parameters.selectedModule.moduleStatus === false
        || parameters.selectedModule.controllerStatus === false)
        && hasModules()">
    <div class="module-inactive__card">
        <div class="module-inactive__header bg-style"></div>
        <div class="module-inactive__content">
            <icon [iconName]="'alarm'"
                [className]="'module-inactive__icon'"
                [iconSize]="40">
            </icon>
            <div *ngIf="subtitles.downloaded
                && !parameters.selectedModule.controllerStatus &&
                parameters.selectedModule.moduleStatus">
                <h2 class="module-inactive__title">{{ subtitle(1206) }}</h2>
                <p class="module-inactive__text">{{subtitle(12848)}}</p>
            </div>
            <div *ngIf="subtitles.downloaded
                && !parameters.selectedModule.moduleStatus">
                <h2 class="module-inactive__title">{{ subtitle(1205) }}</h2>
                <ul class="module-inactive__list">
                    <ng-container *ngFor="let value of subtitle(12849).split('-'); let key = index">
                        <li class="module-inactive__text"
                            *ngIf="key!==0">
                            {{ value}}
                        </li>
                    </ng-container>
                </ul>
            </div>
        </div>
    </div>
</div>
